/**
 * @incternal
 */
export var DEFAULT_ID_SEPARATOR = '|';
